<template>
  <v-dialog v-model="modelAddress" width="800px" v-on:update:modelValue="fechar">
    <v-btn icon="mdi-close" size="x-small" class="btn-close" @click="fechar"></v-btn>
    <v-card v-if="page == 'selecao'">
      <v-card-text class="pa-4 pa-lg-8" v-if="getConfig.storeConfig != null">
        <v-row>
          <v-col class="py-2">
            <b class="text-color-black text-xlarge">{{ isEntrega == 0 ? 'ESCOLHA A UNIDADE DE RETIRADA' : 'ESCOLHA O ENDEREÇO DE ENTREGA' }}</b>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="v-col-12 v-col-lg-6 d-flex align-center justify-center justify-lg-start py-2">
            <span class="text-color-0">Selecione uma das modalidades:</span>
          </v-col>
          <v-col class="v-col-12 v-col-lg-6 d-flex align-center justify-center justify-lg-end py-2">
            <v-btn-toggle :mandatory="true" v-model="isEntrega" variant="outlined" color="var(--color-two)" class="text-color-0">
              <v-btn :value="2" v-if="getConfig.storeConfig.min_express_value_order >= 0">Express</v-btn>
              <v-btn :value="1" v-if="getConfig.storeConfig.min_delivery_value_order >= 0">Entrega</v-btn>
              <v-btn :value="0" v-if="getConfig.storeConfig.min_withdrawal_value_order >= 0">Retirada</v-btn>
            </v-btn-toggle>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="py-2">
            <div v-if="isEntrega == 2">
              <div class="border painel-enderecos rounded" v-if="loadingAddresses">
                <v-skeleton-loader type="image, image" width="100%" height="112px" class="with-margin"></v-skeleton-loader>
              </div>
              <div class="border painel-enderecos rounded" v-else>
                <v-card variant="tonal" class="ma-2 cursor-pointer" @click="selectedAddress = e.address_id" :color="selectedAddress == e.address_id ? 'var(--color-one)': '#aaa'" v-for="e in getAlladdresses" :key="e.address_id">
                  <v-card-text class="text-color-0">
                    <v-row>
                      <v-col class="v-col-1 d-none d-lg-flex align-center">
                        <v-radio v-model="selectedAddress" :value="e.address_id" :color="selectedAddress == e.address_id ? 'var(--color-one)': ''"></v-radio>
                      </v-col>
                      <v-col class="v-col-12 v-col-lg-6 text-left">
                        <b v-if="e.address_nickname != '' && e.address_nickname != null">{{ e.address_nickname }}</b><br>
                        {{ e.street }}, {{ e.num }}<br>
                        {{ e.district }} - {{ e.city }} - {{ e.state }}<br>
                        <b>CEP:</b> {{ e.zip_code }}<br>
                        <b v-if="e.complement != '' && e.complement != null">Complemento:</b> {{ e.complement }}
                      </v-col>
                      <v-col v-if="e.area != null && e.area.express != null" class="v-col-12 v-col-lg-5 d-flex flex-wrap align-space-between">
                        <div class="w-100 text-start text-lg-end" v-if="e.area.express != null && e.area.express.is_able == 1">
                          Até <b>{{ getConfig.storeConfig.max_qtd_items_express }} itens</b> em no máximo {{ formatTime(e.area.express.estimated_time) }}.
                        </div>
                        <div v-else class="w-100 text-start text-lg-end">
                          <b class="text-color-red">Indisponível no momento.</b><br>
                          Disponível a partir de <b>{{ $formatDate(e.area.express.first_window.date + " 00:00:00", { weekday: 'long' } ) }},</b><br>
                          {{ $formatDate(e.area.express.first_window.date + " 00:00:00") }} das {{ e.area.express.first_window.start.split(":")[0] }}h às {{ e.area.express.first_window.end.split(":")[0] }}h
                        </div>
                        <div class="w-100 d-flex align-end justify-start justify-lg-end">
                          <span v-if="e.area.express.shipping > 0" class="text-color-1 mr-2">Frete: <b>{{ $formatNumber(e.area.express.shipping, {style: 'currency', currency: 'BRL'}) }}</b></span><b class="text-color-green mr-2" v-else>Frete Grátis</b>| <b class="ms-2 text-decoration-underline" @click.stop="verHorarios(e)">Ver Horários</b>
                        </div>
                      </v-col>
                      <v-col v-else-if="e.area != null && e.area.express == null" class="v-col-12 v-col-lg-5 d-flex align-center justify-end text-end">
                        <b class="text-color-red">Não fazemos entrega express para esta região</b>
                      </v-col>
                      <v-col v-else class="v-col-12 v-col-lg-5 d-flex align-center justify-end text-end">
                        <b class="text-color-red">Fora da área de entrega</b>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </div>
            </div>
            <div v-else-if="isEntrega == 1">
              <div class="border painel-enderecos rounded" v-if="loadingAddresses">
                <v-skeleton-loader type="image, image" width="100%" height="112px" class="with-margin"></v-skeleton-loader>
              </div>
              <div class="border painel-enderecos rounded" v-else>
                <v-card variant="tonal" class="ma-2 cursor-pointer" @click="selectedAddress = e.address_id" :color="selectedAddress == e.address_id ? 'var(--color-one)': '#aaa'" v-for="e in getAlladdresses" :key="e.address_id">
                  <v-card-text class="text-color-0">
                    <v-row>
                      <v-col class="v-col-1 d-none d-lg-flex align-center">
                        <v-radio v-model="selectedAddress" :value="e.address_id" :color="selectedAddress == e.address_id ? 'var(--color-one)': ''"></v-radio>
                      </v-col>
                      <v-col class="v-col-12 v-col-lg-6 text-left">
                        <b v-if="e.address_nickname != '' && e.address_nickname != null">{{ e.address_nickname }}</b><br>
                        {{ e.street }}, {{ e.num }}<br>
                        {{ e.district }} - {{ e.city }} - {{ e.state }}<br>
                        <b>CEP:</b> {{ e.zip_code }}<br>
                        <b v-if="e.complement != '' && e.complement != null">Complemento:</b> {{ e.complement }}
                      </v-col>
                      <v-col v-if="e.area != null" class="v-col-12 v-col-lg-5 d-flex flex-wrap align-space-between">
                        <div class="w-100 text-start text-lg-end" v-if="e.area.first_window != null">
                          A partir de <b>{{ $formatDate(e.area.first_window.date + " 00:00:00", { weekday: 'long' } ) }},</b><br>
                          {{ $formatDate(e.area.first_window.date + " 00:00:00") }} das {{ e.area.first_window.start.split(":")[0] }}h às {{ e.area.first_window.end.split(":")[0] }}h
                        </div>
                        <div class="w-100 text-start text-lg-end" v-else>
                          <b>Nenhum horário disponível no momento.</b>
                        </div>
                        <div class="w-100 d-flex align-end justify-start justify-lg-end">
                          <span v-if="e.area.shipping > 0" class="text-color-1 mr-2">Frete: <b>{{ $formatNumber(e.area.shipping, {style: 'currency', currency: 'BRL'}) }}</b></span><b class="text-color-green mr-2" v-else>Frete Grátis</b> <span v-if="e.area.first_window != null">|</span> <b class="ms-2 text-decoration-underline" v-if="e.area.first_window != null" @click.stop="verHorarios(e)"> Ver Horários</b>
                        </div>
                      </v-col>
                      <v-col v-else class="v-col-12 v-col-lg-5 d-flex align-center justify-end">
                        <b class="text-color-red">Fora da área de entrega</b>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </div>
            </div>
            <div v-else>
              <div class="border painel-enderecos rounded" v-if="loadingStores">
                <v-skeleton-loader type="image, image" width="100%" height="112px" class="with-margin"></v-skeleton-loader>
              </div>
              <div class="border painel-enderecos rounded" v-else>
                <v-card variant="tonal" class="ma-2 cursor-pointer" @click="selectedAddress = e.store_id" :color="selectedAddress == e.store_id ? 'var(--color-one)': '#aaa'" v-for="e in getAllStorePickup" :key="e.store_id">
                  <v-card-text class="text-color-0">
                    <v-row>
                      <v-col class="v-col-2 v-col-lg-1 align-center">
                        <v-radio v-model="selectedAddress" :value="e.store_id" :color="selectedAddress == e.store_id ? 'var(--color-one)': ''"></v-radio>
                      </v-col>
                      <v-col class="v-col-10 v-col-lg-6 text-left">
                        <b v-if="e.address_nickname != '' && e.address_nickname != null">{{ e.address_nickname }}</b><br>
                        {{ e.street }}, {{ e.num }}<br>
                        {{ e.district }} - {{ e.city }} - {{ e.state }}<br>
                        <b>CEP:</b> {{ e.zip_code }}<br>
                        <b v-if="e.complement != '' && e.complement != null">Complemento:</b> {{ e.complement }}
                      </v-col>
                      <v-col v-if="e.first_window != null" class="v-col-10 offset-2 offset-lg-0 v-col-lg-5 d-flex flex-wrap align-space-between">
                        <div class="w-100 text-start text-lg-end" v-if="e.first_window != null">
                          A partir de <b>{{ $formatDate(e.first_window.date + " 00:00:00", { weekday: 'long' } ) }},</b><br>
                          {{ $formatDate(e.first_window.date + " 00:00:00") }} das {{ e.first_window.start.split(":")[0] }}h às {{ e.first_window.end.split(":")[0] }}h
                        </div>
                        <div class="w-100 d-flex align-end justify-start justify-lg-end">
                          <b class="text-color-green mr-2">Frete Grátis</b>| <b class="ms-2 text-decoration-underline" @click.stop="verHorarios(e)">Ver Horários</b>
                        </div>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </div>
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="v-col-12 v-col-lg-6 d-flex align-center justify-center justify-lg-start py-2">
            <span class="text-color-1 cursor-pointer" @click="registerAddress()">[ + ] Adicionar endereço de entrega</span>
          </v-col>
          <v-col class="v-col-12 v-col-lg-6 d-flex align-center justify-center justify-lg-end py-2">
            <span v-if="isEntrega == 2 && getConfig.storeConfig.min_express_value_order > 0" class="text-color-0">Valor mínimo para express: <b>{{ $formatNumber(getConfig.storeConfig.min_express_value_order, {style: 'currency', currency: 'BRL'}) }}</b></span>
            <span v-else-if="isEntrega == 1 && getConfig.storeConfig.min_delivery_value_order > 0" class="text-color-0">Valor mínimo para entrega: <b>{{ $formatNumber(getConfig.storeConfig.min_delivery_value_order, {style: 'currency', currency: 'BRL'}) }}</b></span>
            <span v-else-if="isEntrega == 0 && getConfig.storeConfig.min_withdrawal_value_order > 0" class="text-color-0">Valor mínimo para retirada: <b>{{ $formatNumber(getConfig.storeConfig.min_withdrawal_value_order, {style: 'currency', currency: 'BRL'}) }}</b></span>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="py-2">
            <v-btn variant="flat" :disabled="selectedAddress == null" block size="x-large" class="bg-color-2 text-color-white" @click="confirmSelection()">Confirmar</v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-card v-if="page == 'horarios'">
      <v-card-text class="pa-4 pa-lg-8">
        <v-row>
          <v-col cols="1" class="py-2 d-flex align-center">
            <v-icon icon="mdi-chevron-left" class="cursor-pointer text-color-2" @click="page = 'selecao'"></v-icon>
          </v-col>
          <v-col cols="11" class="py-2 d-flex align-center">
            <b class="text-color-black text-xlarge">HORÁRIOS DE {{ isEntrega ? 'ENTREGA' : 'RETIRADA' }}</b></v-col>
        </v-row>
        <v-row v-if="selectedHorario != null">
          <v-col class="v-col-12 v-col-lg-9 py-2 text-color-0">
            <b v-if="isEntrega">Entrega:</b><b v-else>Retirada:</b> {{ selectedHorario.street }}, {{ selectedHorario.num }} - {{ selectedHorario.district }} - {{ selectedHorario.city }}/{{ selectedHorario.state }}
          </v-col>
          <v-col class="v-col-12 v-col-lg-3 py-2 d-flex align-start justify-end" v-if="isEntrega == 0 || (isEntrega == 1 && selectedHorario.area != null)">
            <span class="text-color-1 mr-2" v-if="isEntrega == 1 && selectedHorario.area.shipping > 0"><b>Frete: {{ $formatNumber(selectedHorario.area.shipping, {style: 'currency', currency: 'BRL'}) }}</b></span>
            <span class="text-color-green mr-2" v-else><b>Frete Grátis</b></span>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="py-2">
            <div class="border painel-horarios rounded">
              <v-expansion-panels variant="accordion">
                <v-expansion-panel v-for="(h, index) in horarios" :key="index">
                  <v-expansion-panel-title class="text-color-0">
                    <span class="d-none d-lg-block text-large"><b class="text-color-1 text-capitalize">{{ $formatDate(h.date + " 00:00:00", { weekday: 'long' } ) }}</b>, <b>{{ $formatDate(h.date + " 00:00:00", { year: 'numeric', month: 'long', day: 'numeric' }) }}</b></span>
                    <span class="d-block d-lg-none"><b class="text-color-1 text-capitalize">{{ $formatDate(h.date + " 00:00:00", { weekday: 'long' } ) }}</b>, <b>{{ $formatDate(h.date + " 00:00:00", { year: 'numeric', month: 'long', day: 'numeric' }) }}</b></span>
                  </v-expansion-panel-title>
                  <v-expansion-panel-text class="text-color-0">
                    <span v-for="(t, index2) in h.times" :key="index2">Das {{ t.start.split(":")[0] }}h às {{ t.end.split(":")[0] }}h<br></span>
                  </v-expansion-panel-text>
                </v-expansion-panel>
              </v-expansion-panels>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapState, mapGetters, mapActions } from 'vuex';
export default {
  name: 'DialogAddress',
  data(){
    return {
      page: '',
      isEntrega: null,
      modelAddress: false,
      selectedAddress: null,
      horarios: null,
      selectedHorario: null
    }
  },
  props: {
    startPage: {
      type: String,
      default: 'selecao'
    },
    startIsEntrega: {
      type: Number,
      default: 1
    },
    model: {
      type: Boolean,
      default: false
    },
    fechar: {
      type: Function,
      default: null
    }
  },
  computed: {
    ...mapGetters('user', {
      getSelectedAddress: 'getSelectedAddress',
      getAlladdresses: 'getAlladdresses',
      getAddressById: 'getAddressById'
    }),
    ...mapGetters('main', {
      getConfig: 'getConfig',
      getAllStorePickup: 'getAllStorePickup',
    }),
    ...mapState('user', {
      loadingAddresses: 'loadingAddresses',
    }),
    ...mapState('main', {
      loadingStores: 'loadingStores',
    }),
  },
  watch: {
    model: function (){
      this.modelAddress = this.model;
      if(this.modelAddress){
        if(this.getSelectedAddress.destiny_type == 0 && this.getConfig.storeConfig.min_withdrawal_value_order < 0){
          this.isEntrega = 1;
        } else {
          this.isEntrega = this.startIsEntrega != null ? this.startIsEntrega : this.getSelectedAddress.destiny_type;
        }
      } else {
        this.page = this.startPage;
      }
    },
    startPage: function(p){
      this.page = p;
    },
    'getSelectedAddress': function (){
      this.selectedAddress = this.getSelectedAddress.destiny_type ? this.getSelectedAddress.address_id: this.getSelectedAddress.store_id;
    },
    isEntrega: function(n){
      if(n >= 1){
        this.selectedAddress = null;
        this.loadAddresses(true).then(function(){
          if(this.page == "horarios"){
            if(this.getSelectedAddress.destiny_type >= 1){
              this.selectedHorario = this.getSelectedAddress;
            } else {
              this.selectedHorario = this.getAlladdresses[0];
            }
            this.verHorarios(this.selectedHorario);
          }
        }.bind(this));
      } else {
        this.selectedAddress = null;
        this.getStorePickup().then(function(){
          if(this.page == "horarios"){
            if(this.getSelectedAddress.destiny_type == 0){
              this.selectedHorario = this.getSelectedAddress;
            } else {
              this.selectedHorario = this.getAllStorePickup[0];
            }
            this.verHorarios(this.selectedHorario);
          }
        }.bind(this));
      }
    }
  },
  methods: {
    ...mapActions('user', {
      loadAddresses: 'loadAddresses',
      changeAddress: 'changeAddress',
      deliveryTimes: 'deliveryTimes'
    }),
    ...mapActions('main', {
      getStorePickup: 'getStorePickup',
      storeTimes: 'storeTimes',
    }),
    formatTime(t){
      if(t < 60){
        return t+ " minutos";
      } else {
        let h = Math.floor(t/60);
        let m = Math.round(((t/60)-h)*60);
        return h+"h"+m;
      }
    },
    verHorarios(address){
      if(this.isEntrega >= 1){
        this.deliveryTimes({ id: address.address_id, express: (this.isEntrega == 2 ? '1' : '0') }).then(function(response){
          this.horarios = response;
        }.bind(this));
      } else {
        this.storeTimes(address.store_id).then(function(response){
          this.horarios = response;
        }.bind(this));
      }
      this.selectedHorario = address;
      this.page = 'horarios';
    },
    confirmSelection(){
      if(this.isEntrega == 2 && this.getAddressById(this.selectedAddress).area != null && this.getAddressById(this.selectedAddress).area.express == null){
        this.emitter.emit('dialogMessage', { title: "Ops!", message: "Infelizmente não efetuamos entrega express para este endereço." });
      } else if(this.isEntrega == 2 && this.getAddressById(this.selectedAddress).area != null && this.getAddressById(this.selectedAddress).area.express != null && this.getAddressById(this.selectedAddress).area.express.is_able == 0){
        this.emitter.emit('dialogMessage', { title: "Ops!", message: "Infelizmente não efetuamos entrega express para este endereço no momento." });
      } else if(this.isEntrega >= 1 && this.getAddressById(this.selectedAddress).area == null){
        this.emitter.emit('dialogMessage', { title: "Ops!", message: "Infelizmente não efetuamos entrega para este endereço." });
      } else {
        this.changeAddress({ destiny_type: this.isEntrega, destiny_id: this.selectedAddress } ).then(function(retorno){
          if(retorno == true){
            this.fechar();
          } else {
            this.emitter.emit('dialogMessage', { title: "Ops!", message: retorno });
          }
        }.bind(this));
      }
    },
    registerAddress(){
      this.fechar();
      this.emitter.emit('dialogAddress', { address: null });
    }
  },
  mounted(){
    this.page = this.startPage;
    this.isEntrega = this.startIsEntrega;
    if(this.getSelectedAddress != null){
      this.selectedAddress = this.getSelectedAddress.destiny_type ? this.getSelectedAddress.address_id: this.getSelectedAddress.store_id;
    }
  }
}
</script>